// Import ACTION id's
import {
    SAVE_MATCH_RESULT_ASYNC,
    GET_MATCH_RESULTS_ASYNC,
    STORE_PAST_MATCH_RESULTS,
    RESET_HISTORY_STATE} from '../actions/history';

const initState = {
    history: []
};

export const historyReducer = (state = initState, action) =>{
    switch(action.type){

        case SAVE_MATCH_RESULT_ASYNC:
            console.log('SAVE_MATCH_RESULT_ASYNC_reducer');
            console.log(action.payload);
            return state;

        case GET_MATCH_RESULTS_ASYNC:
            return state;

        case STORE_PAST_MATCH_RESULTS:
            console.log('\nPOPULATE_MATCH_RESULTS_reducer');

            return {
                ...state,
                history: action.jsonObj
            };

        case RESET_HISTORY_STATE:
            console.log(RESET_HISTORY_STATE);

            return {
                history: []
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/history.js